import Vue from "vue";
// import "classlist-polyfill";

import constant from "@/constant";
import "font-awesome/css/font-awesome.min.css";
import "element-ui/lib/theme-chalk/index.css";
import "./element";
import "@/assets/css/element-variables.scss";
import "@/assets/css/index.scss";
import "@/assets/css/public.css";

import VueProgressBar from "vue-progressbar";

import App from "./App.vue";
import router from "./router";
import store from "./store/";
import req from "@/assets/js/req";
import { errorScroll } from "@/assets/js/error_scroll";
import util from "@/util";
import cache from "@/assets/js/cache";
import log from "@/assets/js/log";
import belongToConsignment from "@/components/fund/belongToConsignment.vue";
import lowRiskDialog from "./components/form/lowRiskDialog.vue";
import changePwdDialog from "./components/form/changePwdDialog.vue";
import { applyGrayscale, applyTheme, getTheme, isGrayscaleEnabled } from "@/assets/js/theme.js";
let _conf = util.getConfig();
Vue.config.productionTip = true;
const EXTERNAL_TRADE_LIST_ROUTE_MAP = {
    buyfund: "fund",
    generalbuy: "glist"
};

function getExternalTradeInfo(route) {
    const routeName = route && route.name;
    const listRouteName = EXTERNAL_TRADE_LIST_ROUTE_MAP[routeName];
    const fundcode = util.filterCode(((route && route.query) || {}).fundcode || "");
    if (!listRouteName || !fundcode) {
        return null;
    }
    return {
        fundcode,
        tradeRouteName: routeName,
        listRouteName
    };
}

function getLoginTradeRedirect(route) {
    const query = (route && route.query) || {};
    const tradeRouteName = query.autotrade || "";
    const listRouteName = EXTERNAL_TRADE_LIST_ROUTE_MAP[tradeRouteName];
    const fundcode = util.filterCode(query.fundcode || "");
    if (!listRouteName || !fundcode) {
        return null;
    }
    return {
        fundcode,
        tradeRouteName,
        listRouteName
    };
}

// use vue-progressbar
Vue.use(VueProgressBar, {
    color: "rgb(143, 255, 199)",
    failedColor: "red",
    height: "2px"
});

Vue.prototype.$lowRiskDialog = (message) => {
    // 最低风险提示弹窗
    const ModalComponent = Vue.extend(lowRiskDialog);
    // modalInstance 实际上是一个独立的 Vue 实例，它没有自动继承或包含父应用的路由实例。
    const modalInstance = new ModalComponent({
        data() {
            return {
                currentRouter: router // 将 router 传递给组件
            };
        }
    });
    // 将弹窗挂载到body上
    modalInstance.$mount();
    document.body.appendChild(modalInstance.$el);
    Vue.nextTick(() => {
        // 显示弹窗
        modalInstance.openDialog(message);
    });
};

Vue.prototype.$belongToDialog = function (title, message) {
    // 引导开户弹窗
    const ModalComponent = Vue.extend(belongToConsignment);
    const modalInstance = new ModalComponent({});
    // 将弹窗挂载到body上，并显示+
    modalInstance.$mount();
    document.body.appendChild(modalInstance.$el);
    Vue.nextTick(() => {
        modalInstance.openDialog(title, message);
    });
};

Vue.prototype.$changePwdDialog = function () {
    // 修改密码弹窗
    const ModalComponent = Vue.extend(changePwdDialog);
    const modalInstance = new ModalComponent({});
    // 将弹窗挂载到body上，并显示+
    modalInstance.$mount();
    document.body.appendChild(modalInstance.$el);
    Vue.nextTick(() => {
        modalInstance.openDialog();
    });
};

//  Number 对象的 parseInt 和 parseFloat 方法兼容IE
if (Number.parseInt === undefined) Number.parseInt = window.parseInt;
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat;
// bind router guard to start/stop progressbar
router.beforeEach(function (to, from, next) {
    const userOtherInfo = cache.getUserOtherInfo();
    const externalTradeInfo = getExternalTradeInfo(to);
    const loginTradeRedirect = getLoginTradeRedirect(to);
    try {
        Vue.prototype.$msgbox.close();
    } catch (ex) {
        /* console.log(ex); */
    }
    if (externalTradeInfo && (!from || !from.name)) {
        const redirectQuery = {
            fundcode: externalTradeInfo.fundcode,
            autotrade: externalTradeInfo.tradeRouteName
        };
        if (!store.state.login.status) {
            next({ name: "login", query: redirectQuery });
            return false;
        }
        next({ name: externalTradeInfo.listRouteName, query: redirectQuery });
        return false;
    }
    if (to.name === "login" && store.state.login.status && loginTradeRedirect) {
        next({
            name: loginTradeRedirect.listRouteName,
            query: {
                fundcode: loginTradeRedirect.fundcode,
                autotrade: loginTradeRedirect.tradeRouteName
            }
        });
        return false;
    }
    // 跳转登录页面，如果路由配置中要求登录，但登录状态为false 注:允许未登录不注册直接开户
    if (
        to.meta.requiresAuth &&
        !store.state.login.status &&
        to.path !== "/securitycenter/bindnewacct"
    ) {
        log.action({
            eventkey: "login",
            eventtitle: "登录",
            referpagecode: from.name,
            eventvalue: { msg: "跳转页面[" + to.path + "]时没有权限" }
        });
        next({ path: "/" });
        return false;
    } else if (
        !to.meta.requiresAuth &&
        store.state.login.status &&
        to.path !== "/errGeneral" &&
        to.path !== "/errNetwork" &&
        to.path !== "/error404"
    ) {
        log.action({
            eventkey: "home",
            eventtitle: "我的资产",
            referpagecode: from.name,
            eventvalue: {
                msg: "跳转页面[" + to.path + "]时已有登录权限，返资产页面..."
            }
        });
        next({ path: "/home" });
        return false;
    } else if (
        userOtherInfo &&
        userOtherInfo.specialflag &&
        (userOtherInfo.specialflag == "1" ||
            userOtherInfo.specialflag == "2" ||
            userOtherInfo.specialflag == "3") &&
        to.path != "/securitycenter/changetpwd" &&
        to.path != "/securitycenter/changelpwd"
    ) {
        Vue.prototype.$changePwdDialog();
        return false;
    }
    // 路由自定义检查
    if (to.meta.requiresCheck) {
        if (!to.meta.requiresCheck.func(to, from, next, to.meta.requiresCheck.params)) {
            return false;
        }
    }
    log.action({
        eventkey: to.name,
        eventtitle: to.meta.nameText,
        referpagecode: from.name,
        eventvalue: {
            msg: "跳转" + to.meta.nameText + "页面[" + to.path + "]",
            fundcode: to.query.fundcode || ""
        }
    });
    Vue.prototype.$Progress.start();
    // store.dispatch("setRouterCache", {name: to.name, path: to.path, params: to.params});
    next();
});
router.afterEach(function (to, from) {
    // 加载下一个页面默认滚动到顶部
    window.scrollTo(0, 0);
    Vue.prototype.$Progress.finish();
});
Vue.prototype.$req = req;
Vue.prototype.$util = util;
Vue.prototype.$cache = cache;
Vue.prototype.$log = log;
Vue.prototype.$errorScroll = errorScroll;
Vue.prototype.$const = constant;
Vue.prototype.$store = store;
log.info("初始化缓存...");
let initVue = () => {
    document.getElementById("cacheLoading").style.display = "none";
    new Vue({
        router,
        store,
        render: (h) => h(App)
    }).$mount("#app");
};
let initData = async () => {
    const skin = await getTheme();
    const theme = (skin && skin.__THEME_CODE__) || "main";
    const grayscaleEnabled = isGrayscaleEnabled(skin);
    if (!localStorage.getItem("__THEME__")) {
        localStorage.setItem("__THEME__", theme);
    }
    applyTheme(theme);
    applyGrayscale(grayscaleEnabled);

    const params = util.getUrlParams() || {};
    if (
        params.location === "jweb" &&
        (router.history.current.name === null || router.history.current.name === "")
    ) {
        const _x = JSON.parse(sessionStorage.getItem("_a") || localStorage.getItem("_a") || "{}");
        const _b = sessionStorage.getItem("_b") || localStorage.getItem("_b") || "";
        if (_x.token && _b === "1") {
            sessionStorage.setItem("_a", JSON.stringify(_x));
            cache.init().then(function () {
                store.dispatch("login", _x).then(() => {
                    if (params.proto) {
                        const _y = params.proto;
                        util.fundRiskCheckWeb(store, router, params, (res) => {
                            if (res) {
                                const _x = Object.assign({}, res);
                                sessionStorage.setItem(
                                    _y === "buy" ? "buyfund" : "generalbuy",
                                    JSON.stringify(_x)
                                );
                                initVue();
                            } else {
                                initVue();
                            }
                        });
                        return;
                    }
                    initVue();
                });
            });
            return;
        }
    }
    if (params.token && params.token !== "") {
        cache.setSession(params);
        cache.init().then(() => {
            store.dispatch("login", params).then(() => {
                initVue();
            });
        });
    } else {
        cache.init().then(function () {
            if (store.state.login.status && sessionStorage.getItem("_b") === null) {
                const _x = JSON.parse(sessionStorage.getItem("_a") || "{}");
            }
            initVue();
        });
    }
};
initData();
// 解决ie9下 elementUI NavMenu 使用new MouseEvent报错问题
(function (window) {
    try {
        let test = new MouseEvent("test");
        return false; // No need to polyfill
    } catch (e) {
        // Need to polyfill - fall through
    }

    // Polyfills DOM4 MouseEvent
    var MouseEventPolyfill = function (eventType, params) {
        params = params || { bubbles: false, cancelable: false };
        var mouseEvent = document.createEvent("MouseEvent");
        mouseEvent.initMouseEvent(
            eventType,
            params.bubbles,
            params.cancelable,
            window,
            0,
            params.screenX || 0,
            params.screenY || 0,
            params.clientX || 0,
            params.clientY || 0,
            params.ctrlKey || false,
            params.altKey || false,
            params.shiftKey || false,
            params.metaKey || false,
            params.button || 0,
            params.relatedTarget || null
        );

        return mouseEvent;
    };

    MouseEventPolyfill.prototype = Event.prototype;

    window.MouseEvent = MouseEventPolyfill;
})(window);
// 前端异常捕获
window.onerror = function (msg, _url, num) {
    log.error({ msg: msg, url: _url, num: num });
};
// Promise过程异常捕获
window.addEventListener("unhandledrejection", (event) => {
    log.error({ promise: event.reason });
});
// Vue全局异常捕获 系统错误捕获
const errorHandler = (error, vm) => {
    log.error({ vueerror: error, vm: vm });
};
Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error) => errorHandler(error, this);
